import { render, staticRenderFns } from "./Embaixador.vue?vue&type=template&id=3d5b068c&scoped=true"
import script from "./Embaixador.vue?vue&type=script&lang=js"
export * from "./Embaixador.vue?vue&type=script&lang=js"
import style0 from "./Embaixador.vue?vue&type=style&index=0&id=3d5b068c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b068c",
  null
  
)

export default component.exports